import { render } from "./sectionSelect.vue?vue&type=template&id=930992b6&scoped=true"
import script from "./sectionSelect.vue?vue&type=script&lang=js"
export * from "./sectionSelect.vue?vue&type=script&lang=js"

import "./sectionSelect.vue?vue&type=style&index=0&id=930992b6&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930992b6"]])

export default __exports__